import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { authAPI } from '../services/api';
import './Login.css';
import myshieldLogo from '../assets/myshield-logo.png';

const ForgotPassword: React.FC = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await authAPI.forgotPassword(email);
      setSent(true);
    } catch {
      setError('Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <video
        className="video-background"
        autoPlay
        loop
        muted
        playsInline
        disablePictureInPicture
        controlsList="nodownload nofullscreen noremoteplayback"
        onContextMenu={(e) => e.preventDefault()}
      >
        <source src="/background-video.mp4" type="video/mp4" />
      </video>
      <div className="video-overlay" />

      <div className="login-box visible">
        <div className="login-logo">
          <img src={myshieldLogo} alt="Myshield Logo" />
        </div>

        {sent ? (
          <div style={{ textAlign: 'center', padding: '8px 0 16px' }}>
            <div style={{ fontSize: '40px', marginBottom: '12px' }}>📧</div>
            <h3 style={{ margin: '0 0 10px', color: '#002060', fontSize: '17px' }}>Check your email</h3>
            <p style={{ color: '#4a5568', fontSize: '14px', lineHeight: 1.6, margin: '0 0 20px' }}>
              If an account with that email exists, we've sent a password reset link. It expires in 1 hour.
            </p>
            <button className="login-button" onClick={() => navigate('/login')}>
              Back to Sign In
            </button>
          </div>
        ) : (
          <>
            <h3 style={{ margin: '0 0 6px', color: '#002060', fontSize: '17px' }}>Forgot your password?</h3>
            <p style={{ color: '#718096', fontSize: '13px', margin: '0 0 20px', lineHeight: 1.5 }}>
              Enter your email address and we'll send you a link to reset your password.
            </p>

            {error && <div className="error-message">{error}</div>}

            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="email">Email Address</label>
                <input
                  type="email"
                  id="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  disabled={loading}
                  placeholder="Enter your email address"
                  autoComplete="email"
                />
              </div>
              <button type="submit" className="login-button" disabled={loading || !email.trim()}>
                {loading ? 'Sending…' : 'Send Reset Link'}
              </button>
            </form>

            <div style={{ textAlign: 'center', marginTop: '18px' }}>
              <button
                onClick={() => navigate('/login')}
                style={{ background: 'none', border: 'none', color: '#718096', fontSize: '13px', cursor: 'pointer', textDecoration: 'underline' }}
              >
                ← Back to Sign In
              </button>
            </div>
          </>
        )}

        <div className="login-footer">
          <p>© 2026 Yourshield Ltd. All rights reserved.</p>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
